import { render, staticRenderFns } from "./userPlan.vue?vue&type=template&id=2c460f32&scoped=true&"
import script from "./userPlan.vue?vue&type=script&lang=ts&"
export * from "./userPlan.vue?vue&type=script&lang=ts&"
import style0 from "./userPlan.vue?vue&type=style&index=0&id=2c460f32&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c460f32",
  null
  
)

export default component.exports